module.exports = __webpack_public_path__ + "static/anushree-e1a3ad1616eea7e90055fed8f281d5a9.jpg";